import React from "react";
import { Route, useRouteMatch, Redirect } from "react-router-dom";
import mixpanel from "mixpanel-browser";

import { useAxiosPost } from "../../Services/Api";
import { Container, Cover, Form, Input, BtnLogin, Title } from "./style";
import StepOne from "./Steps/StepOne";
import StepTwo from "./Steps/StepTwo";
import StepThree from "./Steps/StepThree";

export default function SignIn() {
  const { url } = useRouteMatch();
  const [{ data, loading, error }, login] = useAxiosPost("auth/login");

  const handleSubmit = (data) => {
    login(data);
  };

  React.useEffect(() => {
    // window.zE("webWidget", "hide");
  }, []);

  if (data) {
    localStorage.setItem("token", data.token.accessToken);
    window.location = "/";
  }

  return (
    <Container>
      <Cover />
      <div style={{ width: "600px" }}>
        <Route exact path={`${url}/step-one`} component={StepOne} />
        <Route exact path={`${url}/step-two`} component={StepTwo} />
        <Route exact path={`${url}/step-three`} component={StepThree} />
        <Redirect path={`${url}`} to={`${url}/step-one`} />
      </div>
    </Container>
  );
}
